import React, { useEffect, useState } from "react";
import { FaHome, FaBookOpen } from "react-icons/fa";
import { HiDeviceMobile } from "react-icons/hi";
import { BsCalendarCheck, BsThreeDotsVertical } from "react-icons/bs";
import { FiX } from "react-icons/fi";
import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { CgMenuBoxed } from "react-icons/cg";

const MobileFooter = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setisLoading] = useState(false);

  const getData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(`${REACT_APP_API_PORT}user/homepage/header-menu-details`);
      setisLoading(false);
      if (res.data.status) {
        setData(res.data.data);
      }
    } catch (err) {
      setisLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const getPathname = (url) => {
    try {
      return new URL(url).pathname || "/";
    } catch (err) {
      console.warn("Invalid URL:", url);
      return "/";
    }
  };

  return (
    <>
      {/* Mobile Footer */}
      <div className="fixed bottom-0 left-0 w-full py-3 md:hidden bg-[#111] text-black z-[30]">
        <div className="flex justify-around">
          {data && data.slice(0, 4).map((item, index) => (
            <NavLink
              to={getPathname(item.pageurl)}
              key={index}
              className={({ isActive }) =>
                `flex flex-col items-center text-sm ${
                  isActive ? "text-primary" : "text-white"
                } hover:text-primary`
              }
            >
              <div className="text-xl mb-1">
                {item?.image ? (
                  <img className="w-6 h-5" src={IMAGE_URL + item?.image} alt={item.menu_name} />
                ) : (
                  <CgMenuBoxed />
                )}
              </div>
              <div className="text-[12px]">{item.menu_name}</div>
            </NavLink>
          ))}

          {/* Three Dots Menu */}
          {data && data.length > 4 && (
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="flex flex-col items-center text-sm text-white hover:text-primary"
            >
              <div className="text-xl mb-1">
                <BsThreeDotsVertical />
              </div>
              <div className="text-[12px]">More</div>
            </button>
          )}
        </div>
      </div>

      {/* Sliding Menu */}
      {data && data.length > 4 && (
        <div
          className={`fixed bottom-0 left-0 w-full bg-background-back2 text-white transform transition-transform duration-300 z-[31] ${
            isMenuOpen ? "translate-y-0" : "translate-y-full"
          }`}
        >
          <div className="p-4 border-b border-gray-700 flex justify-between items-center">
            <span className="text-lg font-semibold">More Options</span>
            <button
              onClick={() => setIsMenuOpen(false)}
              className="text-sm text-white hover:text-red-500 transition"
            >
              <FiX className="w-6 h-6" />
            </button>
          </div>
          <ul className="space-y-4 p-4">
            {data.slice(4).map((item, index) => (
              <li key={index}>
                <NavLink
                  to={getPathname(item.pageurl)}
                  className={({ isActive }) =>
                    `block text-md mb-1 flex items-center ${
                      isActive ? "text-primary" : "text-white"
                    } hover:text-primary`
                  }
                >
                  {item?.image && (
                    <img className="w-6 h-5 mr-2" src={IMAGE_URL + item?.image} alt={item.menu_name} />
                  )}
                  {item.menu_name}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default MobileFooter;


// import React, { useEffect, useState } from "react";
// import { BsThreeDotsVertical } from "react-icons/bs";
// import { FiX } from "react-icons/fi";
// import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
// import axios from "axios";
// import { NavLink } from "react-router-dom";
// import { CgMenuBoxed } from "react-icons/cg";

// const MobileFooter = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [data, setData] = useState([]);

//   const getData = async () => {
//     try {
//       const res = await axios.get(
//         `${REACT_APP_API_PORT}user/homepage/header-menu-details`
//       );
//       if (res.data.status) {
//         setData(res.data.data);
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     getData();
//   }, []);

//   const getPathname = (url) => {
//     try {
//       return new URL(url).pathname || "/";
//     } catch {
//       return "/";
//     }
//   };

//   return (
//     <>
//       {/* 🔥 MOBILE FOOTER */}
//       <div className="fixed bottom-0 left-0 w-full py-3 md:hidden bg-[#0b0b0b] z-[30]">
//         <div className="flex justify-around relative">

//           {data &&
//             data.slice(0, 4).map((item, index) => (
//             <NavLink
//   to={getPathname(item.pageurl)}
//   key={index}
//   className="relative flex flex-col items-center text-sm"
// >
// {({ isActive }) => (
//   <>
//     {/* ICON / IMAGE */}
//     <div
//       className={`
//         relative text-xl mb-1 flex items-center justify-center
//         transition-all duration-300
//         ${isActive ? "scale-110 drop-shadow-[0_0_8px_#e1307a]" : ""}
//       `}
//     >
//       {item?.image ? (
//         <div className="relative w-6 h-5">
//           {/* ORIGINAL IMAGE */}
//           <img
//             src={IMAGE_URL + item?.image}
//             alt={item.menu_name}
//             className={`
//               w-full h-full transition-all duration-300
//               ${isActive ? "opacity-0" : "opacity-80"}
//             `}
//           />

//           {/* 🔥 GRADIENT IMAGE */}
//           {isActive && (
//             <div
//               className="
//                 absolute inset-0
//                 bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
//                 drop-shadow-[0_0_10px_rgba(225,48,122,0.6)]
//               "
//               style={{
//                 WebkitMaskImage: `url(${IMAGE_URL + item?.image})`,
//                 WebkitMaskRepeat: "no-repeat",
//                 WebkitMaskSize: "contain",
//                 WebkitMaskPosition: "center",
//                 maskImage: `url(${IMAGE_URL + item?.image})`,
//                 maskRepeat: "no-repeat",
//                 maskSize: "contain",
//                 maskPosition: "center",
//               }}
//             />
//           )}
//         </div>
//       ) : (
//         <CgMenuBoxed
//           className={`
//             ${
//               isActive
//                 ? "font-extrabold scale-110 bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] bg-clip-text text-transparent"
//                 : "text-white/70"
//             }
//           `}
//         />
//       )}
//     </div>

//     {/* TEXT */}
//     <div
//       className={`
//         text-[12px] transition-all duration-300
//         ${
//           isActive
//             ? "font-extrabold tracking-wide bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] bg-clip-text text-transparent drop-shadow-[0_0_6px_rgba(148,67,255,0.7)]"
//             : "text-white/70"
//         }
//       `}
//     >
//       {item.menu_name}
//     </div>
//   </>
// )}
// </NavLink>


//             ))}

//           {/* MORE MENU */}
//           {data && data.length > 4 && (
//             <button
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               className="flex flex-col items-center text-sm text-white/70"
//             >
//               <div className="text-xl mb-1">
//                 <BsThreeDotsVertical />
//               </div>
//               <div className="text-[12px]">More</div>
//             </button>
//           )}
//         </div>
//       </div>

//       {/* 🔥 SLIDE MENU */}
//       {data && data.length > 4 && (
//         <div
//           className={`fixed bottom-0 left-0 w-full bg-black text-white transform transition-transform duration-300 z-[31] ${
//             isMenuOpen ? "translate-y-0" : "translate-y-full"
//           }`}
//         >
//           <div className="p-4 border-b border-gray-700 flex justify-between items-center">
//             <span className="text-lg font-semibold">More Options</span>
//             <button onClick={() => setIsMenuOpen(false)}>
//               <FiX className="w-3 h-6" />
//             </button>
//           </div>

//           <ul className="space-y-4 p-4">
//             {data.slice(4).map((item, index) => (
//               <li key={index}>
//                 <NavLink
//                   to={getPathname(item.pageurl)}
//                   className="flex items-center text-white/80 hover:text-white"
//                 >
//                   {item?.image && (
//                     <img
//                       className="w-6 h-5 mr-2"
//                       src={IMAGE_URL + item?.image}
//                       alt={item.menu_name}
//                     />
//                   )}
//                   {item.menu_name}
//                 </NavLink>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//     </>
//   );
// };

// export default MobileFooter;


